import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (measurementId) {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    console.log("Google Analytics initialized");
  } else {
    console.warn("Google Analytics Measurement ID not provided");
  }
};

// Track page views
export const logPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

// Track custom events
export const logEvent = (category, action, label = "", value = 0) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Track user login
export const logLogin = (method) => {
  ReactGA.event({
    category: "User",
    action: "Login",
    label: method, // e.g., 'Google', 'Email', 'Facebook'
  });
};

// Track user signup
export const logSignup = (method) => {
  ReactGA.event({
    category: "User",
    action: "Signup",
    label: method,
  });
};

// Track errors
export const logError = (description, fatal = false) => {
  ReactGA.event({
    category: "Error",
    action: description,
    label: fatal ? "Fatal" : "Non-Fatal",
  });
};

// Track custom user actions
export const logUserAction = (action, label = "", value = 0) => {
  ReactGA.event({
    category: "User Action",
    action,
    label,
    value,
  });
};

// Set user ID (for authenticated users)
export const setUserId = (userId) => {
  if (userId) {
    ReactGA.set({ userId });
  }
};

// Set user properties
export const setUserProperties = (properties) => {
  ReactGA.set(properties);
};
